import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDeviceUPSControl from './reducers/device-ups-control.reducer';
import {EffectsModule} from '@ngrx/effects';
import {DeviceUPSControlEffects} from './effects/device-ups-control.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceUPSControl', fromDeviceUPSControl.reducer),
    EffectsModule.forFeature([ DeviceUPSControlEffects ]),
  ]
})
export class DeviceUPSControlModule { }
